import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { debounceTime, Subject } from 'rxjs';
import { PurchasesService } from 'src/app/inventory/purchases/purchases.service';
import { SalesOrderService } from 'src/app/inventory/sales-order/sales-order.service';
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";

@Component({
  selector: 'app-viewtracking',
  templateUrl: './viewtracking.component.html',
  styleUrl: './viewtracking.component.scss'
})
export class ViewtrackingComponent implements OnChanges {

  @Input() trackingOptions= [];
  @Input() displayTracking: boolean = false;
  @Input() isReturn: boolean = false;
  @Input() productSerialSettings = null;
  @Input() productId: number = 0;
  @Input() warehouseId: number = 0;
  @Input() billId: number = 0;
  @Input() module: string = '' ;
  @Output() onSubmit = new EventEmitter();
  @Output() onClose = new EventEmitter();
  searchValue: string = '';
  modelChanged = new Subject<string>();
  selectedTracking = [];
  trackingData = [];
  totalTBRecord: number = 0;
  rowsPerPageTB = [100, 200, 300, 500];
  pageNumber: number = 1;
  pageSize: number = 100;
  first: number = 0;
  utilityServiceObj: UtilityService;

  constructor(private utilityService: UtilityService,
    private purchaseService: PurchasesService,
    private salesOrderService: SalesOrderService
  ){
    this.modelChanged.pipe(
      debounceTime(700))
      .subscribe(() => {
        this.onGlobalSearch();
      })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.utilityServiceObj = this.utilityService;
    if(changes?.productId?.currentValue || changes?.warehouseId?.currentValue || 
      changes?.billId?.currentValue){
        this.loadTrackingData(this.pageNumber,this.pageSize,changes?.productId?.currentValue,changes?.warehouseId?.currentValue,
          changes?.billId?.currentValue,'',this.module,this.isReturn);
    }
  }

  changed(event) {
    this.modelChanged.next("");
  }

  onGlobalSearch(){
    this.loadTrackingData(this.pageNumber,this.pageSize,this.productId,this.warehouseId,this.billId,this.searchValue,this.module,this.isReturn);
  }

  loadTrackingData(pageNumber: number,pageSize: number,productId: number,warehouseId: number, billId: number, search: string,module:string,isReturn:boolean){
    const serviceName = module == 'sales' ? this.salesOrderService : this.purchaseService ;
    serviceName.checkSystemTrackingDataForBill(pageNumber,pageSize,productId,warehouseId,billId,search,isReturn).subscribe({
      next: (data) => {
        let { tracking } = data;
        tracking = tracking ?? [];
        this.trackingData = tracking.item1;
        this.totalTBRecord = tracking.item2;
        this.displayTracking = true;
      },
      error: (error) => {
       console.error(error);
      },
    });
  }

  loadTrackingLazy(event){
    this.pageNumber = event.first / event.rows + 1;
    this.pageSize = event.rows;
    this.first = event.first;
    this.loadTrackingData(this.pageNumber,this.pageSize,this.productId,this.warehouseId,this.billId,this.searchValue,this.module,this.isReturn);
  }

  onDialogClose(){
    this.onClose.emit();
  }

  onSave(){
    this.onSubmit.emit(this.selectedTracking);
  }

}
